





















































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ImageModal from '@/app/components/Common/ImageModal.vue'
/* api */
import MachineDetailApi from '@/app/model/api/machineDetailApi'
import MachineMaintenanceListApi from '@/app/model/api/machineMaintenanceListApi'
import GetMachineImgApi from '@/app/model/api/getMachineImgApi'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import Session from '@/app/module/session'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import DateClass from '@/app/module/date'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorInfo,
    ErrorModal,
    Error409Modal,
    Loading,
    ImageModal
  }
})
export default class MachineDetails extends Vue {
  private alertText: string = ''
  private alertTitle: string = ''
  private constantValue: any = []
  private machineType: number|null = null
  private machineData: any = {
    is_valid: null,
    machine_name: '',
    machine_type: null,
    buy_date: '',
    model: '',
    serial_number: '',
    maker_address: '',
    image_path: '',
    working_width: null,
    working_height: null,
    weight: null,
    working_time: null,
    working_performance: null,
    remarks: ''
  }
  private maintenanceData: any = {}
  private displayImg: string = require('@/assets/img/no_image.svg')
  private modalImgPath: string = ''
  /* 表示非表示 */
  private show400ErrorMessage: boolean = false
  private showError409Modal: boolean = false
  private showLoading: boolean = true
  private showMaintenanceLoading: boolean = true
  private showModal: boolean = false
  private showImgLoading: boolean = false

  created () {
    // セレクトボックス情報取得
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.getMachineList()
    this.getMaintenanceList()
  }

  /* ステータスの判定 */
  private judgmentMachineIsValid (status: number) {
    switch (status) {
      case 0:
        return '利用可'

      case 1:
        return '利用不可'

      default:
        return ''
    }
  }

  /* 機械タイプの判定 */
  private judgmentMachineType (type: number) {
    for (let i in this.constantValue.machine_types) {
      if (this.constantValue.machine_types[i].machine_type_id === type) {
        return this.constantValue.machine_types[i].machine_type_name
      }
    }
  }

  private dateToStringYmd (date: any) {
    if (date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '年' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '月' + DateClass.toDoubleDigits(updateDate.getDate()) + '日'
      return formingDate
    }
  }

  private getMachineList () {
    (async () => {
      const result = await MachineDetailApi.getMachineDetail(this.$route.params.machine_id)
      if (result.isOk()) {
        this.machineData = result.getPayload().machine
        this.getDefaultImg()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private getMaimtenanceRemarks (data: any) {
    let remarks = []
    for (let i in data) {
      if (data[i].working_content !== null) {
        remarks.push(data[i].item_name + '(' + data[i].working_content + ')')
      }
    }
    return remarks.join(',')
  }

  private getMaintenanceList () {
    (async () => {
      const result = await MachineMaintenanceListApi.getMachineMaintenanceList(this.$route.params.machine_id)
      if (result.isOk()) {
        this.maintenanceData = result.getPayload().results
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showMaintenanceLoading = false
    })()
  }

  private async getDefaultImg () {
    if (this.machineData.image_path !== null && this.machineData.image_path !== '') {
      this.showImgLoading = true
      const result = await GetMachineImgApi.getMachineImgData(this.machineData.machine_id)
      // resultがオブジェクト型の場合、エラーで画像が存在しないため「登録なし」を表示
      if (typeof result === 'object') {
        this.displayImg = require('@/assets/img/no_image.svg')
      } else {
        this.displayImg = String(result)
      }
      this.showImgLoading = false
    } else {
      this.displayImg = require('@/assets/img/no_image.svg')
    }
  }

  private showImgModal () {
    if (this.machineData.image_path !== null && this.machineData.image_path !== '') {
      this.getModalImg(this.machineData.machine_id)
    }
  }

  private async getModalImg (id: string) {
    const result = await GetMachineImgApi.getMachineImgData(id)
    this.showModal = true
    if (typeof result === 'object') {
      this.modalImgPath = require('@/assets/img/no_image.svg')
    } else {
      this.modalImgPath = String(result)
    }
  }

  private doEdit () {
    this.$router.push('/master/machine/' + this.$route.params.machine_id + '/edit').catch(e => {})
  }

  private doCancel () {
    this.$router.push('/master/machine').catch(e => {})
  }
}
